import React from 'react'
import NavItem from './item';
import styles from './index.module.scss?v=20220629'

function Nav({ isToggle, navList }) {
    return (
        <nav className={styles.nav}>
            <NavItem isToggle={isToggle} navList={navList}></NavItem>
        </nav>
    )
}

export default Nav;